import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hubspot-auth-complete',
  templateUrl: './hubspot-auth-complete.component.html',
  standalone: false
})

export class HubSpotAuthCompleteComponent implements OnInit {
  ngOnInit(): void {
    window.close();
  }

}
